import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";

const GrazeBoxFields = ({ item, updateItem, grazeBoxes, getDietExtra }) => {
  const selectedGrazeBox = grazeBoxes.find((g) => g._id === item.productId);

  const buildCustomizations = (size, diet, gift) => [
    { key: "size", value: size?.name || "" },
    { key: "dietary", value: diet?.name || "None" },
    { key: "giftPackaging", value: gift ? "Yes" : "No" },
  ];

  const handleProductChange = (e) => {
    const box = grazeBoxes.find((b) => b._id === e.target.value);
    if (!box) return;

    console.log(box);

    updateItem(item._id, {
      productId: box._id,
      name: box.name, // 👈 Use displayName as item name
      displayName: box.name,
      selectedSize: null,
      size: null,
      selectedDiet: null,
      giftPackaging: false,
      customizations: [],
    });
  };

  const handleSizeChange = (e) => {
    const selectedSize = selectedGrazeBox?.sizes.find(
      (s) => s.sizeId === e.target.value
    );

    if (!selectedSize) return;

    updateItem(item._id, {
      selectedSize,
      size: {
        name: selectedSize.name,
      },
      customizations: buildCustomizations(
        selectedSize,
        item.selectedDiet,
        item.giftPackaging
      ),
    });
  };

  const handleDietChange = (e) => {
    const selectedDiet = selectedGrazeBox?.dietaryOptions.find(
      (d) => d.name === e.target.value
    );

    updateItem(item._id, {
      selectedDiet,
      customizations: buildCustomizations(
        item.selectedSize,
        selectedDiet,
        item.giftPackaging
      ),
    });
  };

  const handleGiftChange = (e) => {
    const isGift = e.target.value === "yes";
    updateItem(item._id, {
      giftPackaging: isGift,
      customizations: buildCustomizations(
        item.selectedSize,
        item.selectedDiet,
        isGift
      ),
    });
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          select
          label="Graze Box Type"
          fullWidth
          value={item.productId || ""}
          onChange={handleProductChange}>
          {grazeBoxes.map((box) => (
            <MenuItem key={box._id} value={box._id}>
              {box.displayName || box.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {selectedGrazeBox && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Size"
              fullWidth
              value={item.selectedSize?.sizeId || ""}
              onChange={handleSizeChange}>
              {selectedGrazeBox.sizes.map((s) => (
                <MenuItem key={s.sizeId} value={s.sizeId}>
                  {s.name} – serves up to {s.servesUpTo}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Dietary Restriction"
              fullWidth
              value={item.selectedDiet?.name || ""}
              onChange={handleDietChange}>
              <MenuItem value="">None</MenuItem>
              {selectedGrazeBox.dietaryOptions.map((d) => (
                <MenuItem key={d.name} value={d.name}>
                  {d.name}
                  {getDietExtra(d, item.selectedSize) > 0 &&
                    ` (+$${getDietExtra(d, item.selectedSize).toFixed(2)})`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              select
              label="Gift Packaging"
              fullWidth
              value={item.giftPackaging ? "yes" : "no"}
              onChange={handleGiftChange}>
              <MenuItem value="no">No</MenuItem>
              <MenuItem value="yes">Yes (+$3.00)</MenuItem>
            </TextField>
          </Grid>
        </>
      )}
    </>
  );
};

export default GrazeBoxFields;
